import {
    LESS_512_MEDIA_QUERY,
    LESS_768_MEDIA_QUERY,
} from '../../../consts/adaptive';

const layoutWrapper = {
    maxWidth: 1280,
    padding: [16, 24, 0],
    margin: '0 auto',
    boxSizing: 'border-box',
    [LESS_768_MEDIA_QUERY]: {
        padding: [0, 10],
    },
};

export const styles = {
    wrapper: {
        width: '100%',
        backgroundColor: '#F3F9FF',
        paddingBottom: 80,
    },
    content: {
        position: 'relative',
        backgroundColor: '#ffffff',
        minHeight: 250,
        ...layoutWrapper,
    },
    mainWrapper: {
        width: '100%',
        display: 'flex',
        borderTop: '1px solid #E3E3E3',
        backgroundColor: 'white',
        boxSizing: 'border-box',
    },
    noReviewsWrapper: {
        ...layoutWrapper,
        width: '100%',

        '& > article': {
            backgroundColor: 'white',
            marginBottom: 0,
        },
    },
    mainContent: {
        width: '100%',
        padding: '0 17px',
        overflow: 'hidden',
    },
    headingWrapper: {
        ...layoutWrapper,
        marginBottom: 28,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    heading: {
        margin: 0,
        paddingTop: 44,
        fontFamily: 'Open Sans, Arial, sans-serif',
        fontWeight: 600,
        fontSize: 32,
        color: '#313140',
    },
    button: {
        width: 170,
        height: 34,
        background: '#FFD600',
        borderRadius: 4,
        fontFamily: 'Open Sans, Arial, sans-serif',
        fontSize: 14,
        alignItems: 'center',
        textAlign: 'center',
        color: '#313140',
        border: 'none',
        cursor: 'pointer',

        ['&:hover']: {
            backgroundColor: '#ffe352',
        },
    },
    [LESS_512_MEDIA_QUERY]: {
        heading: {
            fontSize: 22,
            marginBottom: 0,
        },
        button: {
            width: 140,
            height: 28,
        },
        wrapper: {
            paddingBottom: 10,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
